import React from 'react';
import { getContext } from 'common';
import styled from './styles';

/**
 *  CellEditorRenderer is a custom cellRenderer component for inactive editable cell
 *  It is for to achieve the hover and focus border effect
 */
const CellEditorRenderer = ({ value, api, ...otherProps }) =>
  getContext(({ RTL, theme }) => (
    <styled.CellEditorWrapper $rtl={RTL} $theme={theme.DATAGRID} {...otherProps}>
      <styled.CellEditorBorder className="ccfk-cell-editor-renderer-border" compactMode={api.context.compactMode}>
        {value}
      </styled.CellEditorBorder>
    </styled.CellEditorWrapper>
  ));

export default CellEditorRenderer;
